import { Spacer } from "components/general/Spacer/Spacer";
import { Hash } from "viem";
import { useTokenListByChain } from "../../../hooks/useTokenListByChain";

export const SamePartyTooltipContent = ({
  currentTokenAddress,
  otherTokenAddress,
  isTaker,
}: {
  currentTokenAddress: Hash;
  otherTokenAddress: Hash;
  isTaker: boolean;
}) => {
  const tokenList = useTokenListByChain();
  const currentTokenName = tokenList?.[currentTokenAddress].name;
  const otherTokenName = tokenList?.[otherTokenAddress].name;
  if (isTaker) {
    return (
      <>
        Paying {currentTokenName} is unavailable when also paying {otherTokenName}.
        <Spacer height={6} />
        If you wish to pay {currentTokenName}, then please remove {otherTokenName}.
      </>
    );
  }

  // Maker side
  return (
    <>
      Receiving {currentTokenName} is unavailable when also receiving {otherTokenName}.
      <Spacer height={6} />
      If you wish to receive {currentTokenName}, then please remove {otherTokenName}.
    </>
  );
};

export const OpposingPartyNon121TooltipContent = ({
  toPay,
  toReceive,
  isTaker,
}: {
  toPay: Hash;
  toReceive: Hash;
  isTaker: boolean;
}) => {
  const tokenList = useTokenListByChain();
  const toPayName = tokenList?.[toPay].name;
  const toReceiveName = tokenList?.[toReceive].name;
  if (isTaker) {
    return (
      <>
        Paying {toPayName} is unavailable when also receiving {toReceiveName}.
        <Spacer height={6} />
        If you wish to pay {toPayName}, then please select a different token other than{" "}
        {toReceiveName} to receive.
      </>
    );
  }
  return (
    <>
      Receiving {toReceiveName} is unavailable when also paying {toPayName}.
      <Spacer height={6} />
      If you wish to receive {toReceiveName}, then please select a different token other than{" "}
      {toPayName} to pay.
    </>
  );
};

export const AllOtherTokensDisabledHoverContent = ({
  nativeToken,
  wrappedToken,
  isTaker,
}: {
  nativeToken: Hash;
  wrappedToken: Hash;
  isTaker: boolean;
}) => {
  const tokenList = useTokenListByChain();
  const nativeTokenName = tokenList?.[nativeToken].name;
  const wrappedTokenName = tokenList?.[wrappedToken].name;
  return (
    <>
      {isTaker ? "Paying" : "Receiving"} additional tokens is unavailable when paying and receiving
      between {nativeTokenName} and {wrappedTokenName}.
      <Spacer height={6} />
      If you wish to {isTaker ? "pay" : "receive"} additional tokens then please remove either{" "}
      {nativeTokenName} or {wrappedTokenName}.
    </>
  );
};
